<template>
  <main>
    <div class="terms-of-use__HelpPageContainer-sc-1q47rqf-2 qzCqi"><h3
      class="terms-of-use__Heading-sc-1q47rqf-0 cmiOop">ĐIỀU KHOẢN GIAO DỊCH TRÊN EPIS STORE</h3>
      <h2 class="terms-of-use__Title-sc-1q47rqf-3 cYvZSS">A. Định nghĩa:</h2>
      <div>
        <div class="terms-of-use__TextItem-sc-1q47rqf-6 guRRxL">1. Khách hàng:</div> <!-- --> <!-- -->Là các cá nhân/tổ
        chức tại lãnh thổ Việt Nam, có nhu cầu đặt mua hàng hóa nhập khẩu theo hình thức phi mậu dịch để sử dụng và sản
        phẩm mậu dịch để sử dụng (Không được phép kinh doanh).
      </div>
      <div>
        <div class="terms-of-use__TextItem-sc-1q47rqf-6 guRRxL">2. EPIS Việt Nam:</div> <!-- --> <!-- -->Là website bán
        hàng của Công Ty TNHH EPIS Việt Nam.
      </div>
      <br>
      <h2 class="terms-of-use__Title-sc-1q47rqf-3 cYvZSS">B. Trách nhiệm các bên:</h2>
      <div class="terms-of-use__TextItem-sc-1q47rqf-6 guRRxL">1. Trách nhiệm của EPIS Việt Nam:</div>
      <p>Chính sách về trách nhiệm với hàng hóa thông qua các hoạt động giao dịch của epis.vn được thực hiện dựa trên
        các điều khoản của các website quốc tế và theo luật pháp Việt Nam:</p>
      <ul class="terms-of-use__UlStyle-sc-1q47rqf-4 kxHIPX">
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Bảo đảm quá trình giao dịch của khách hàng và người bán
          diễn ra an toàn.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Theo dõi, cập nhật thông tin, tư vấn và hỗ trợ quý khách
          hàng để hoàn tất các thủ tục giúp việc giao dịch được thành công.
        </li>
      </ul>
      <div class="terms-of-use__TextItem-sc-1q47rqf-6 guRRxL">2. Trách nhiệm của khách hàng:</div>
      <ul class="terms-of-use__UlStyle-sc-1q47rqf-4 kxHIPX">
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Người mua có trách nhiệm thanh toán toàn bộ tiền hàng theo
          niêm yết tại website epis.vn.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Tìm hiểu kỹ thông tin chi tiết sản phẩm trước khi đặt mua
          hàng như: kích thước, chủng loại, chất liệu, xuất xứ… hàng hóa trước khi đặt hàng.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Cam kết chỉ đặt những mặt hàng phục vụ cho mục đích sử
          dụng. Tuân thủ theo pháp luật Việt Nam.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Không đặt mua các sản phẩm có tính chất phản động, bạo
          lực, đồi trụy, không phù hợp với thuần phòng mỹ tục Việt Nam và các sản phẩm pháp luật cấm sử dụng, lưu trữ,
          lưu hành.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Đảm bảo tính trung thực của thông tin mô tả sản phẩm.</li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Đảm bảo cung cấp đúng sản phẩm như mô tả tại website
          epis.vn
        </li>
      </ul>
      <br>
      <h2 class="terms-of-use__Title-sc-1q47rqf-3 cYvZSS">C. Điều khoản chung: </h2>
      <div class="terms-of-use__TextItem-sc-1q47rqf-6 guRRxL">1. Trách nhiệm của EPIS Việt Nam:</div>
      <ul class="terms-of-use__UlStyle-sc-1q47rqf-4 kxHIPX">
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">epis.vn là đơn vị bán hàng và chịu sự quản lý của Công Ty
          TNHH EPIS VIỆT NAM. EPIS Việt Nam chịu trách nhiệm hoàn tiền và đổi trả sản phẩm cho khách hàng 15 ngày kể từ
          ngày đơn hàng được giao đến tay khách hàng.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Tổng thời gian đặt hàng vận chuyển thông thường trong
          khoảng 10 -20 ngày (không tính ngày nghỉ, lễ)
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Người mua hiểu rõ quyền lợi, trách nhiệm và hoàn toàn tự
          nguyện khi đặt mua hàng hóa tại epis.vn.
        </li>
        <li class="terms-of-use__LiStyle-sc-1q47rqf-5 hUlFai">Mọi giao dịch thông qua EPIS Việt Nam được mặc định việc
          quý khách hàng đã đọc và cam kết việc đồng ý theo chính sách này.
        </li>
      </ul>
      <br>
      <div style="margin-bottom:100px" class="terms-of-use__TextItem-sc-1q47rqf-6 guRRxL">Quý khách hàng cần đọc rõ
        những điều khoản được quy định tại chính sách này để tránh những vấn đề ngộ nhận ngoài ý muốn.
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "TermOfUSe",
  data() {
    return {}
  },
  components: {},
  mounted() {

  },
  methods: {},
  created() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/TermsOfUse.vue